import { useSelector } from 'react-redux';
import { UPDATE_WORK_SESSIONS_STATE } from 'src/gql/workSessionsAPI';
import { useAuthorizedMutation } from 'src/utils/useAuthorizedMutation';
import {
  getCurrentSession,
  getIsManualRewind,
  getPlayTimestamp,
  getSessionTimePassedSeconds,
} from 'src/reducers/workSessions/workSessionsSelectors';
import { useEffect, useRef } from 'react';
import { StoredWorkSessionsState } from 'src/models/workSessions';

interface GQLVariables {
  newState: StoredWorkSessionsState;
}

export function useSyncWorkSessionsState(isFetched: boolean) {
  const [updateWorkSessionsState] = useAuthorizedMutation<unknown, GQLVariables>(UPDATE_WORK_SESSIONS_STATE);
  const playTimestamp = useSelector(getPlayTimestamp);
  const currentSession = useSelector(getCurrentSession);
  const sessionTimePassedSeconds = useSelector(getSessionTimePassedSeconds);
  const isManualRewind = useSelector(getIsManualRewind);
  const isFetchedRef = useRef(false);

  useEffect(() => {
    if (isFetchedRef.current && !isManualRewind) {
      updateWorkSessionsState({
        variables: {
          newState: {
            currentSession,
            sessionTimePassedSeconds,
            playTimestamp,
          },
        },
      });
    }
  }, [currentSession, isManualRewind, playTimestamp, sessionTimePassedSeconds, updateWorkSessionsState]);

  useEffect(() => {
    isFetchedRef.current = isFetched;
  }, [isFetched]);
}
